/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify'; //토스트(toast)
import { confirmAlert } from 'react-confirm-alert'; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";

class MyReview extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 20,
    dataList: [],
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };

  _getData = async (gotoPage) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === '') {
    } else {
      const result = await this._getDataApi(gotoPage);
      const intReturn = result.data[0].intReturn;
      const pageCount = result.data[0].pageCount;
      const con = result.data[0].con;
      const dataList = result.data[0].listData;
      //console.log(con)
      if (this._isMounted) {
        if (intReturn === 0) {
          if (con > 0) {
            //console.log('con > 0')
            this.setState({
              gotoPage: gotoPage,
              con: con,
              pageCount: pageCount,
              dataList: dataList,
              hasMore: pageCount < gotoPage ? false : true,
            });
          } else {
            //console.log('con < 0')
            this.setState({
              gotoPage: 1,
              con: con,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        } else {
          //console.log('intReturn <> 0')
          this.setState({
            gotoPage: 1,
            con: con,
            dataList: [],
            hasMore: pageCount < gotoPage ? false : true,
          });
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/myReview', {
        params: {
          userid: loginId,
          authId: authId,
          gotoPage: gotoPage,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  _renderItem = () => {
    const { dataList } = this.state;
    const { imgUrl } = this.props;
    const list = dataList.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.regDate}</td>
          <td>
            <span
              onClick={() => this._goItem(item.contentSerial)}
              style={{ cursor: 'pointer' }}
            >
              {item.title}
            </span>
          </td>
          <td>
            <div className="text_line">{item.content}</div>
          </td>
          <td>
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => this._onDelete(item.idx)}
              src={imgUrl + '/img/mypage/del2.png'}
            />
          </td>
        </tr>
      );
    });

    return list;
  };
  _goItem = (contentSerial) => {
    const { setContentSerial } = this.props;

    setContentSerial(contentSerial);
  };
  _onDelete = async (idx) => {
    const result = await this._onDeleteApi(idx);
    const intReturn = result.data[0].intReturn;

    //console.log(intReturn)
    if (intReturn === 0) {
      toast.success('작성된 리뷰가 삭제 되었습니다.');
      this._getData(1);
    } else {
      toast.warn('삭제할 리뷰가 존재하지 안습니다.');
    }
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  _onDeleteApi = (idx) => {
    const { apiUrl, loginId, authId, history } = this.props;
    const at = this.getCookie('at');
    // const at = localStorage.getItem('at');

    return axios
      .post(
        apiUrl + '/myReviewDel',
        {
          params: {
            userid: loginId,
            authId,
            idx: idx,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(idx);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (idx) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._onDelete(idx);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };

  _onAllDelete = () => {
    const { dataList } = this.state;
    if (dataList.length <= 0) {
      toast.warn('삭제할 리뷰가 존재하지 안습니다.');
      return;
    }

    confirmAlert({
      title: '리뷰 전체 삭제',
      message:
        '작성하신 모든 리뷰를 삭제하시겠습니까? 삭제된 데이터는 복구 되지 않습니다.',
      buttons: [
        {
          label: '모두 삭제',
          onClick: async () => {
            const result = await this._onAllDeleteApi();
            const intReturn = result.data[0].intReturn;

            if (intReturn === 0) {
              toast.success('작성된 리뷰가 모두 삭제 되었습니다.');
              this._getData(1);
            } else {
              toast.warn('삭제할 리뷰가 존재하지 안습니다.');
            }
          },
        },

        {
          label: '취소',
          //onClick: () => alert('Click No')
        },
      ],
    });
  };
  _onAllDeleteApi = () => {
    const { apiUrl, loginId, authId } = this.props;

    return axios
      .post(apiUrl + '/myReviewAllDel', {
        params: {
          userid: loginId,
          authId: authId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  _renderPage = () => {
    const { pageCount, gotoPage } = this.state;
    const pageNumbers = [];
    let blockPage = ((gotoPage - 1) / 10) * 10 + 1;
    let i = 0;
    ////console.log(blockPage, pageCount)
    do {
      pageNumbers.push(i);
      blockPage = blockPage + 1;
      i = i + 1;
    } while (i < 10 && i < pageCount);
    ////console.log(pageNumbers)
    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num + 1)}
          className={gotoPage === num + 1 ? 'on' : null}
        >
          {num + 1}
        </span>
      );
    });

    return list;
  };
  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con, pageCount } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        <div className="mypage_content">
          <div className="mypage_group">
            <h1>
              작성한 리뷰<span>({con})</span>
              <div>
                <a style={{ cursor: 'pointer' }} onClick={this._onAllDelete}>
                  전체 삭제
                  <img src={imgUrl + '/img/mypage/del.png'} />
                </a>
              </div>
            </h1>
            <div className="my_table_list">
              <table
                width="100%"
                border="0"
                cellSpacing="0"
                cellPadding="0"
                className="style_table2"
              >
                <colgroup>
                  <col width="13%" />
                  <col width="13%" />
                  <col width="" />
                  <col width="11%" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>작성일</th>
                    <th>작품명</th>
                    <th>내용</th>
                    <th>삭제</th>
                  </tr>
                  {dataList ? this._renderItem() : null}
                </tbody>
              </table>
              <div className="page_no new_page">
                <span style={{ cursor: 'pointer' }} onClick={this._onPrev}>
                  이전
                </span>
                {pageCount > 0 ? (
                  this._renderPage()
                ) : (
                  <span style={{ cursor: 'pointer' }} className="on">
                    1
                  </span>
                )}
                <span style={{ cursor: 'pointer' }} onClick={this._onNext}>
                  다음
                </span>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer position="bottom-right" hideProgressBar />
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyReview));
